export const PROMPT_SUGGESTIONS = [
    {
        label: 'Show my overdue inspections',
        prompt: 'Show me all overdue inspections with their building details'
    },
    {
        label: 'Export deficiency report',
        prompt: 'Generate a deficiency report for the most recent inspection'
    },
    {
        label: 'Upcoming inspections this week',
        prompt: 'Show me all inspections scheduled for this week'
    }
];
export const TECH_PORTAL_PROMPT_SUGGESTIONS = [
    {
        label: 'Upcoming inspections this week',
        prompt: 'Show me all inspections scheduled for this week'
    },
    {
        label: 'Devices for my next inspection',
        prompt: 'Show me the devices for my next scheduled inspection'
    },
    {
        label: 'Access info for my next inspection',
        prompt: 'Show me the access information for my next scheduled inspection'
    }
];
